import "./index.scss";

import React, { Component } from "react";
import {
  changeMenu,
  changeTheme,
  toggleMenu
} from "../../actions/themeActions";

import Icon from "../../assets/Icon";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Title from "./../Title";
import { connect } from "react-redux";
import darkLogo from "./../../assets/logo-dark.png";
import lightLogo from "./../../assets/logo-light.png";

// Images

// Icon

// Redux

class index extends Component {
  setMenuBtnPosition = () => {
    const appWidth = document.querySelector(".app").offsetWidth;
    const containerWidth = document.querySelector(".container").offsetWidth;
    const menuBtn = document.querySelector(".menu-btn");

    if (this.props.showMenu) {
      menuBtn.style.left = `252px`;
    } else {
      menuBtn.style.left = `${(appWidth - containerWidth) / 2 + 30}px`;
    }
  };

  toggleMenu = () => {
    const menu = document.getElementById("menu");

    if (this.props.showMenu) {
      menu.style.left = "-300px";
    } else {
      menu.style.left = 0;
    }

    this.props.toggleMenu();
  };

  setMenuActive = e => {
    const { changeMenu } = this.props;
    changeMenu(e.target.type);
    this.toggleMenu();
  };

  componentDidMount() {
    this.setMenuBtnPosition();
    window.addEventListener("resize", this.setMenuBtnPosition);
  }

  componentDidUpdate() {
    this.setMenuBtnPosition();
  }

  render() {
    const { theme, showMenu, menuActive } = this.props;

    return (
      <header id="header">
        <button
          className={showMenu ? `menu-btn fixed` : "menu-btn"}
          onClick={this.toggleMenu}
        >
          <Icon type={showMenu ? "close" : "menu"} />
        </button>
        <div id="menu" className={theme}>
          <div className="links">
            <Title text={`Menu`} type={`SECTION`} theme={theme} />
            <ul className={`menu-${theme}`}>
              <Link to="/">
                <li
                  className={menuActive === "" ? "menu-active" : ""}
                  type=""
                  onClick={this.setMenuActive}
                >
                  Catálogo de serviços
                </li>
              </Link>
              <Link to="/ServicesQueue">
                <li
                  className={
                    menuActive === "ServicesQueue" ? "menu-active" : ""
                  }
                  type="ServicesQueue"
                  onClick={this.setMenuActive}
                >
                  Lista de atendimento
                </li>
              </Link>
              <Link to="/ProjectsIndicators">
                <li
                  className={
                    menuActive === "ProjectsIndicators" ? "menu-active" : ""
                  }
                  type="ProjectsIndicators"
                  onClick={this.setMenuActive}
                >
                  Indicadores de projetos
                </li>
              </Link>
              <Link to="/Absence">
                <li
                  className={menuActive === "Absence" ? "menu-active" : ""}
                  type="Absence"
                  onClick={this.setMenuActive}
                >
                  Férias e afastamentos
                </li>
              </Link>
              <Link to="/Birthdays">
                <li
                  className={menuActive === "Birthdays" ? "menu-active" : ""}
                  type="Birthdays"
                  onClick={this.setMenuActive}
                >
                  Aniversários no mês
                </li>
              </Link>
              <Link to="/Calendars">
                <li
                  className={menuActive === "Calendars" ? "menu-active" : ""}
                  type="Calendars"
                  onClick={this.setMenuActive}
                >
                  Agendas
                </li>
              </Link>
            </ul>
          </div>
          <div className="options">
            {/*<div className="tvMode">
              <span>Modo TV </span>
            </div>*/}
            <div className="theme">
              <span>Tema</span>
              <div className="themeSpots">
                <div
                  onClick={() => this.props.changeTheme("light")}
                  // className="spot light"
                  className={
                    theme === "light" ? "spot light active" : "spot light"
                  }
                />
                <div
                  onClick={() => this.props.changeTheme("dark")}
                  className={
                    theme === "dark" ? "spot dark active" : "spot dark"
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <Link to="/" className={showMenu ? `logo blur` : "logo"}>
          {theme === "light" ? <img src={lightLogo} alt="logo" /> : null}
          {theme === "dark" ? <img src={darkLogo} alt="logo" /> : null}
          <h1 className={`logo-${theme}`}>STI</h1>
        </Link>
      </header>
    );
  }
}

index.propTypes = {
  theme: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired,
  menuActive: PropTypes.string.isRequired,
  changeTheme: PropTypes.func.isRequired,
  changeMenu: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  showMenu: state.theme.showMenu,
  menuActive: state.theme.menuActive
});

export default connect(
  mapStateToProps,
  { changeTheme, toggleMenu, changeMenu }
)(index);
